(function (root) {
  'use strict';

  const warsawClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const polishDate = new Intl.DateTimeFormat('pl-PL', {
    timeZone: 'UTC', day: 'numeric', month: 'long'
  });

  function getWarsawParts(date) {
    return Object.fromEntries(warsawClock.formatToParts(date)
      .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }

  function nextCutoff(parts, beforeCutoff) {
    const wallTime = Date.UTC(parts.year, parts.month - 1, parts.day + (beforeCutoff ? 0 : 1), 20);
    let instant = wallTime;
    // Resolve the target date's Warsaw offset, including DST changes overnight.
    for (let i = 0; i < 3; i++) {
      const p = getWarsawParts(new Date(instant));
      const renderedWallTime = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
      const correction = wallTime - renderedWallTime;
      instant += correction;
      if (correction === 0) break;
    }
    return instant;
  }

  function getDelivery(now = new Date()) {
    const parts = getWarsawParts(now);
    const beforeCutoff = parts.hour < 20;
    const daysAhead = beforeCutoff ? 1 : 2;
    // Calendar arithmetic deliberately follows the user-provided daily rule.
    // UTC noon avoids DST and browser-timezone shifts when adding calendar days.
    const delivery = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + daysAhead, 12));
    const dispatch = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + (beforeCutoff ? 0 : 1), 12));
    const previousDispatch = new Date(dispatch.getTime() - 86400000);
    const nextDispatch = new Date(dispatch.getTime() + 86400000);
    const dateLabel = polishDate.format(delivery);
    const relativeLabel = beforeCutoff ? 'jutro' : 'pojutrze';
    const cutoff = nextCutoff(parts, beforeCutoff);
    const secondsLeft = Math.max(0, Math.ceil((cutoff - now.getTime()) / 1000));
    const countdown = [Math.floor(secondsLeft / 3600), Math.floor(secondsLeft % 3600 / 60), secondsLeft % 60]
      .map(value => String(value).padStart(2, '0')).join(':');
    return {
      beforeCutoff,
      daysAhead,
      deliveryISO: delivery.toISOString().slice(0, 10),
      dispatchISO: dispatch.toISOString().slice(0, 10),
      previousDispatchISO: previousDispatch.toISOString().slice(0, 10),
      nextDispatchISO: nextDispatch.toISOString().slice(0, 10),
      previousDispatchLabel: polishDate.format(previousDispatch).toLocaleUpperCase('pl-PL'),
      nextDispatchLabel: polishDate.format(nextDispatch).toLocaleUpperCase('pl-PL'),
      dispatchDateLabel: polishDate.format(dispatch).toLocaleUpperCase('pl-PL'),
      dispatchLabel: beforeCutoff ? 'Dziś' : 'Za 1 dzień',
      cutoffISO: new Date(cutoff).toISOString(),
      secondsLeft,
      countdown,
      relativeLabel,
      title: `Dostawa ${relativeLabel}, ${dateLabel}`,
      cutoffLabel: beforeCutoff ? 'do 20:00' : 'do 20:00 jutro',
      polandTime: `${String(parts.hour).padStart(2, '0')}:${String(parts.minute).padStart(2, '0')}`
    };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { getDelivery };
  if (!root.document) return;

  // One timer for all rendered purchase blocks, including theme-editor reloads.
  if (root.dsPlOfferDelivery) { root.dsPlOfferDelivery.refresh(); return; }
  let timer;
  function refresh() {
    clearTimeout(timer);
    const message = getDelivery();
    function update(selector, text) {
      root.document.querySelectorAll(selector).forEach(el => { if (el.textContent !== text) el.textContent = text; });
    }
    update('[data-ds-inpost-day]', message.relativeLabel);
    update('[data-ds-inpost-countdown]', message.countdown);
    update('[data-ds-poland-clock]', message.polandTime);
    update('[data-ds-batch-dispatch]', message.dispatchLabel);
    update('[data-ds-batch-date]', message.dispatchDateLabel);
    update('[data-ds-batch-previous-date]', message.previousDispatchLabel);
    update('[data-ds-batch-next-date]', message.nextDispatchLabel);
    root.document.querySelectorAll('[data-ds-batch-previous-date]').forEach(el => { el.setAttribute('datetime', message.previousDispatchISO); });
    root.document.querySelectorAll('[data-ds-batch-next-date]').forEach(el => { el.setAttribute('datetime', message.nextDispatchISO); });
    root.document.querySelectorAll('[data-ds-batch-rows]').forEach(el => { el.hidden = false; });
    root.document.querySelectorAll('[data-ds-batch-dispatch]').forEach(el => { el.hidden = false; });
    root.document.querySelectorAll('[data-ds-batch-date]').forEach(el => { el.setAttribute('datetime', message.dispatchISO); });
    root.document.querySelectorAll('[data-ds-inpost-day]').forEach(el => {
      el.setAttribute('datetime', message.deliveryISO);
      el.setAttribute('title', message.title);
    });
    root.document.querySelectorAll('[data-ds-inpost-line]').forEach(el => {
      el.setAttribute('title', `${message.title}. Zamów ${message.cutoffLabel} (czas w Polsce). Kurier InPost.`);
    });
    root.document.querySelectorAll('[data-ds-inpost-timing]').forEach(el => { el.hidden = false; });
    // Refresh at the next second boundary, including the 20:00 and midnight switches.
    timer = setTimeout(refresh, 1000 - Date.now() % 1000 + 10);
  }
  root.dsPlOfferDelivery = { refresh };
  root.document.addEventListener('shopify:section:load', refresh);
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  root.document.addEventListener('visibilitychange', () => { if (!root.document.hidden) refresh(); });
  root.addEventListener('pageshow', refresh);
})(globalThis);
